import Header from "../../../components/Header"
import { HeadingPages } from "../../../components/HeadingPages"
import InputFloating from "../../../components/InputFloating"
import { Box, Button, Flex, Text } from "@chakra-ui/react"
import Axios from "axios"
import React from "react"
import { useForm } from "react-hook-form"
import { Card } from "./Card"
import { format, parseISO } from "date-fns"
import { ptBR } from "date-fns/locale"
import { baseURL } from "../../../services/api"
import { Loader } from "../../../components/ComponentLoader/Loader"
import { normalizeString } from "../../../utils/normalizeString"

export function ResumoGravacao() {
  const { register, handleSubmit, watch } = useForm()

  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState([])
  const [allData, setAllData] = React.useState([])
  const [periodo, setPeriodo] = React.useState("")

  async function getDadaResumoProduction(data) {
    setLoading(true)
    const response = await baseURL.post("/pedido/resumo-producao", {
      data_saida: data.data_saida,
      data_entrada: data.dataEntrada,
    })

    setData(response.data)

    const entrada = format(parseISO(data.dataEntrada), "dd 'de' MMMM", {
      locale: ptBR,
    })
    const saida = format(parseISO(data.data_saida), "dd 'de' MMMM", {
      locale: ptBR,
    })

    const periodo = `${entrada} à ${saida}`

    setPeriodo(periodo)

    setLoading(false)
  }

  async function getAllDadaResumoProduction(data) {
    setLoading(true)
    const response = await baseURL.post("/pedido/resumo-producao", {
      data_saida: "",
      data_entrada: "",
    })

    setAllData(response.data)

    setLoading(false)
  }

  const objectGravacoes = {
    Laser: 0,
    Serigrafia: 0,
    Tampografia: 0,
    Uv: 0,
    Transfer: 0,
    Silk: 0,
    Marca: 0,
    Etiqueta: 0,
    Placa: 0,
    "S/Impressão": 0,
    DTF: 0,
    Sublimação: 0,
    "Colorida Total 360° + Brilho": 0,
    "Colorida localizada": 0,
  }

  const objectGravacoesAll = {
    Laser: 0,
    Serigrafia: 0,
    Tampografia: 0,
    Uv: 0,
    Transfer: 0,
    Silk: 0,
    Marca: 0,
    Etiqueta: 0,
    Placa: 0,
    "S/Impressão": 0,
    DTF: 0,
    Sublimação: 0,
    "Colorida Total 360° + Brilho": 0,
    "Colorida localizada": 0,
  }

  data.lista?.forEach((item) => {
    Object.keys(objectGravacoes).forEach((tipoGravacao) => {
      if (item.PASSO_ATUAL !== "TÉRMINO DE PERSONALIZAÇÃO") {
        if (item.GRAVACAO.toLowerCase().includes(tipoGravacao.toLowerCase())) {
          objectGravacoes[tipoGravacao] += parseInt(item.QUANTIDADE)
        }
      }
    })
  })

  allData.lista?.forEach((item) => {
    Object.keys(objectGravacoesAll).forEach((tipoGravacao) => {
      if (item.PASSO_ATUAL !== "TÉRMINO DE PERSONALIZAÇÃO") {
        if (item.GRAVACAO.toLowerCase().includes(tipoGravacao.toLowerCase())) {
          objectGravacoesAll[tipoGravacao] += parseInt(item.QUANTIDADE)
        }
      }
    })
  })

  const arrayGravacoes = Object.entries(objectGravacoes).map(([key, value]) => {
    return {
      gravacao: key,
      quantidade: value,
      quantidadeGravacao: data.lista?.filter((item) => {
        if (item.PASSO_ATUAL !== "TÉRMINO DE PERSONALIZAÇÃO") {
          return item.GRAVACAO.toLowerCase().includes(key.toLowerCase())
        }
      }).length,
    }
  })
  // .filter((item) => item.quantidade > 0)

  const totalGravacoes = arrayGravacoes.reduce(
    (acc, item) => {
      const { quantidade, quantidadeGravacao } = item
      return {
        quantidade: acc.quantidade + quantidade,
        quantidadeGravacao: acc.quantidadeGravacao + quantidadeGravacao,
      }
    },
    { quantidade: 0, quantidadeGravacao: 0 },
  )

  const limitedProdAllData = allData.lista?.map((item) => {
    if (item.PREVISAO_SAIDA) {
      return {
        PREVISAO_SAIDA: item.PREVISAO_SAIDA,
      }
    }
  })

  const ultimaData = limitedProdAllData?.reduce((acumulador, valorAtual) => valorAtual)

  const arrayGravacoesAllData = Object.entries(objectGravacoesAll).map(([key, value]) => {
    return {
      gravacao: key,
      quantidade: value,
      quantidadeGravacao: allData.lista?.filter((item) => {
        if (item.PASSO_ATUAL !== "TÉRMINO DE PERSONALIZAÇÃO") {
          return item.GRAVACAO.toLowerCase().includes(key.toLowerCase())
        }
      }).length,
    }
  })
  // .filter((item) => item.quantidade > 0)

  const totalGravacoesAllData = arrayGravacoesAllData.reduce(
    (acc, item) => {
      const { quantidade, quantidadeGravacao } = item
      return {
        quantidade: acc.quantidade + quantidade,
        quantidadeGravacao: acc.quantidadeGravacao + quantidadeGravacao,
      }
    },
    { quantidade: 0, quantidadeGravacao: 0 },
  )

  React.useEffect(() => {
    getAllDadaResumoProduction()
  }, [])

  return (
    <>
      {loading && <Loader />}

      <HeadingPages name={"Resumo Gravação"} />
      <Box w="100%" h="100vh" bgColor={"#fff"}>
        <Flex
          pt={"2rem"}
          alignItems="center"
          justifyContent="center"
          gap="1rem"
          maxW="500px"
          mx="auto"
          as="form"
          onSubmit={handleSubmit(getDadaResumoProduction)}
        >
          <InputFloating
            label="Data de entrada"
            type={"date"}
            bgColor={"transparent"}
            color={"#378BBF"}
            {...register("dataEntrada")}
          />
          <InputFloating
            label="Data de saída"
            type={"date"}
            bgColor={"transparent"}
            color={"#378BBF"}
            {...register("data_saida")}
          />
          <Button variant="ghost" color={"#378BBF"} type="submit" isLoading={loading}>
            Buscar
          </Button>
        </Flex>

        <Box
          w="100%"
          maxW="1330px"
          mx="auto"
          display={"flex"}
          alignItems={"flex-start"}
          justifyContent={"center"}
          gap={"39px"}
          mt={"2rem"}
        >
          <Flex flexDir={"column"} alignItems={"flex-start"} paddingBlock={"16px"} mt={"4.9rem"}>
            <Text
              bg={"#378BBF"}
              paddingBlock={"11px"}
              paddingInline={"32px"}
              color={"#fff"}
              width={"100%"}
              mb={2}
              maxW={"400px"}
            >
              Gravações
            </Text>
            {arrayGravacoesAllData.map((item, index) => (
              <Flex
                width={"100%"}
                maxW={"400px"}
                key={index}
                alignItems={"center"}
                justifyContent={"space-between"}
                bg={index % 2 === 0 ? "#F5F5F5" : "#FFFFFF"}
                paddingBlock={"4px"}
                paddingInline={"36px"}
              >
                <Text>{item.gravacao}:</Text>
              </Flex>
            ))}
          </Flex>
          <Card arrayGravacoes={arrayGravacoes} periodo={periodo} totalGravacoes={totalGravacoes} />
          <Card
            production
            ultimaData={ultimaData}
            arrayGravacoes={arrayGravacoesAllData}
            totalGravacoes={totalGravacoesAllData}
          />
        </Box>
      </Box>
    </>
  )
}
